import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.general.title',
        defaultMessage: '3DS settings',
    },
    alert: {
        id: 'modal.3ds.general.alert',
        defaultMessage: "We sometimes need to confirm it's really you before a payment goes through",
    },
    sms: {
        id: 'modal.3ds.general.sms',
        defaultMessage: 'SMS',
    },
    email: {
        id: 'modal.3ds.general.email',
        defaultMessage: 'Email',
    },
    bio: {
        id: 'modal.3ds.general.bio',
        defaultMessage: 'Biometrics',
    },
    approval: {
        id: 'modal.3ds.general.in_wallet',
        defaultMessage: 'In-wallet approval',
    },
    security: {
        id: 'modal.3ds.general.security',
        defaultMessage: 'Security questions',
    },
    learnMore: {
        id: 'modal.3ds.general.learn_more',
        defaultMessage: 'Learn more',
    },
})
